var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header-view-wrapper"},[_c('Header')],1),_c('div',{staticClass:"router-view-wrapper"},[_c('router-view'),_c('Bottom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }